<div class="card-doacao" (click)="onRowClick(dados)">
  <!-- Código -->
  <div class="col-code">
    <span class="col-label">Código</span>
    <span class="code-badge">#{{ codigo }}</span>
  </div>

  <!-- Título -->
  <div class="col-title">
    <span class="col-label">Campanha Apoiada</span>
    <h4 class="title-text" [title]="titulo">{{ titulo }}</h4>
  </div>

  <!-- Data -->
  <div class="col-meta">
    <span class="col-label">Data</span>
    <span class="val-date">{{ data }}</span>
  </div>

  <!-- Meta -->
  <div class="col-meta">
    <span class="col-label">Meta da Causa</span>
    <span class="val-goal">{{ Objectivo | money }} Kz</span>
  </div>

  <!-- Valor Doado -->
  <div class="col-meta">
    <span class="col-label">Valor Apoiado</span>
    <span class="val-donated">{{ doado | money }} Kz</span>
  </div>

  <!-- Estado -->
  <div class="col-status">
    <span class="col-label">Estado</span>
    <p-tag [severity]="getSeverity(estado)" [value]="estado"></p-tag>
  </div>

  <!-- Menu Ações -->
  <div class="col-actions" (click)="$event.stopPropagation()">
    <p-menu
      #menuRef
      [model]="getMenuActions(dados)"
      [popup]="true"
      appendTo="body"
      [autoZIndex]="true"
      [baseZIndex]="10000"
    ></p-menu>

    <button
      type="button"
      class="btn-action-trigger"
      (click)="openMenu($event, menuRef)"
      title="Opções de Pagamento"
    >
      <i class="fa-solid fa-ellipsis-vertical"></i>
    </button>
  </div>
</div>